/* Combine all available reducers to a single root reducer.
 **/

import filters from "reducers/filters";
import keywordTriggeredBanner from "reducers/keywordTriggeredBanner";
import rankingStrategy from "reducers/rankingStrategy";
import result from "reducers/result";
import search from "reducers/search";
import sortOptions from "reducers/sortOptions";
import suggestions from "reducers/suggestions";
import webcode from "reducers/webcode";

const combined = {
  filters,
  keywordTriggeredBanner,
  rankingStrategy,
  result,
  search,
  sortOptions,
  suggestions,
  webcode,
};

export default combined;
